import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectFabricationDataForPrices } from 'offshore_pcb/pcb_fabrication/slice/selectors';
import { priceSelected } from 'offshore_pcb/pcb_fabrication/slice/fabricationSlice';
import {
  CAN_NOT_QUOTE_AUTOMATICALLY,
  ERROR,
  PRICE_SELECTED,
  QUOTED,
  QUOTING,
  START,
} from 'shared/data/quoteSteps';

import PriceMatrix from 'shared/components/price/PriceMatrix';
import AutomaticQuoteError from 'shared/components/AutomaticQuoteError';
import CantQuoteAutomatically from 'shared/components/CantQuoteAutomatically';
import QuoteActionBar from 'offshore_pcb/pcb_fabrication/components/QuoteActionBar';
import PcbInstructions from 'offshore_pcb/pcb_fabrication/components/PcbInstructions';
import Terms from 'offshore_pcb/pcb_fabrication/components/Terms';

const Price = () => {
  const dispatch = useDispatch();
  const {
    quote,
    parametersChanged,
    parameters,
    quoteStep,
  } = useSelector(selectFabricationDataForPrices);

  const onPriceSelect = (data) => {
    dispatch(priceSelected(data));
  };

  const lineItem = quote?.line_items[0];


  if (quoteStep === ERROR) {
    return <AutomaticQuoteError />;
  }

  if (quoteStep === CAN_NOT_QUOTE_AUTOMATICALLY) {
    return <CantQuoteAutomatically />;
  }

  return (
    <div className="container-fluid quote-result">
      <div className="row">
        <div className="col-md-12">
          {quoteStep !== QUOTING && <QuoteActionBar />}
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <PriceMatrix
            tableStripe
            lineItem={lineItem}
            parametersChanged={parametersChanged}
            onPriceSelect={onPriceSelect}
            parameters={parameters}
            quoteStep={quoteStep} />
        </div>
      </div>
      {quoteStep === START && <PcbInstructions />}
      {[QUOTED, PRICE_SELECTED].includes(quoteStep) && <Terms />}
    </div>
  );
};

export default Price;
